module.exports = __webpack_public_path__ + "static/media/95.0914c571.png";